jQuery(function () {
	// Header Scroll
	menuScroll();

	// Shop Menu
	shopMenu();

	// General Slideshow on home and wholesale
	generalSlideshow();

	// General Slideshow V2
	generalSlideshowV2();

	// Sustain Slideshow
	sustainSlideshow();

	// Footer Slider
	footerSlider();

	// Wholesale Slider
	wholesaleSlider();

	// Benefits Slider
	benefitsMobileSwiper();

	// Sustain Slider
	checkSustainSliderWidth();

	// Mobile Menu
	$(".header-left-mobile-menu-icon").on("click", function () {
		closeCartMenu();
		closeSearchMenu();
		closeAccountMenu();
		$(".mobile-menu").toggleClass("mobile-menu-active");
		if ($(".mobile-menu-active")[0]) {
			$("html, body").addClass("body-overflow");
		} else {
			$("html, body").removeClass("body-overflow");
		}
	});

	// Mobile Menu Accordion
	$(".navigation ul > li").on("click", function () {
		if ($(this).children(".sub-nav").length > 0) {
			$(this).toggleClass("active").siblings().removeClass("active");
		}
	});

	// Mobile Menu X Icon
	$(".mobile-menu-close-icon").on("click", function () {
		mobileMenuClose();
	});

	// Cart menu
	$(".cart-menu-button").on("click", function () {
		closeAccountMenu();
		closeSearchMenu();
		window.monster_refresh(open);
		toggleCart();
		// $(".cart-menu-modal").toggleClass("cart-menu-modal-active");
		// if ($(".cart-menu-modal-active")[0]) {
		// 	if ($(".header-transparent")[0]) {
		// 		$("header").addClass("header-transparent-disabled");
		// 	}
		// 	if ($(window).width() < 992) {
		// 		$("html, body").addClass("body-overflow");
		// 	} else {
		// 		$("body").addClass("body-overflow");
		// 	}
		// } else {
		// 	if ($(".header-transparent-disabled")[0]) {
		// 		$("header").removeClass("header-transparent-disabled");
		// 	}
		// 	if ($(window).width() < 992) {
		// 		$("html, body").removeClass("body-overflow");
		// 	} else {
		// 		$("body").removeClass("body-overflow");
		// 	}
		// }
	});
	$(".cart-menu-top-close").on("click", function () {
		closeCartMenu();
	});

	// Search Menu
	$(".search-menu-button").on("click", function () {
		closeCartMenu();
		closeAccountMenu();
		$(".search-menu-modal").toggleClass("search-menu-modal-active");
		if ($(".search-menu-modal-active")[0]) {
			if ($(".header-transparent")[0]) {
				$("header").addClass("header-transparent-disabled");
			}

			if ($(window).width() < 992) {
				mobileMenuClose();
			}
			$("html, body").addClass("body-overflow");
		} else {
			if ($(".header-transparent-disabled")[0]) {
				$("header").removeClass("header-transparent-disabled");
			}
			$("html, body").removeClass("body-overflow");
		}
	});

	$(".search-input-close").on("click", function () {
		closeSearchMenu();
	});

	$("#searchinput").on("focus", function () {
		$(this).keyup(function () {
			if (this.value.length > 1) {
				$(".search-menu-results").show();
				// Change also the number of results on '.search-menu-results h3'
			}
		});
	});

	// Account menu
	$(".account-menu-button:not([href]").on("click", function () {
		closeCartMenu();
		closeSearchMenu();
		$(".account-menu-modal").toggleClass("account-menu-modal-active");
		if ($(".account-menu-modal-active")[0]) {
			if ($(".header-transparent")[0]) {
				$("header").addClass("header-transparent-disabled");
			}
			if ($(window).width() < 992) {
				mobileMenuClose();
				$("html, body").addClass("body-overflow");
			}
		} else {
			if ($(".header-transparent-disabled")[0]) {
				$("header").removeClass("header-transparent-disabled");
			}
			if ($(window).width() < 992) {
				$("html, body").removeClass("body-overflow");
			}
		}
	});

	$(".account-menu-top-close").on("click", function () {
		closeAccountMenu();
	});

	$("span.modal-type").on("click", function () {
		var divtohide = $(this).attr("data-hide");
		var divtoshow = $(this).attr("data-show");
		$(divtohide).hide();
		$(divtoshow).show();
	});

	if (document.location.hash == "#login") {
		closeCartMenu();
		closeSearchMenu();
		$(".account-menu-modal").toggleClass("account-menu-modal-active");
		if ($(".account-menu-modal-active")[0]) {
			if ($(".header-transparent")[0]) {
				$("header").addClass("header-transparent-disabled");
			}
			if ($(window).width() < 992) {
				mobileMenuClose();
				$("html, body").addClass("body-overflow");
			}
		} else {
			if ($(".header-transparent-disabled")[0]) {
				$("header").removeClass("header-transparent-disabled");
			}
			if ($(window).width() < 992) {
				$("html, body").removeClass("body-overflow");
			}
		}
	}
});

function menuScroll() {
	if ($(".header-transparent")[0] && $(".general-hero-section")[0]) {
		var finishDivScroll = $(".general-hero-section").offset().top + $(".general-hero-section").height() - 54;
		$(window).scroll(function () {
			var newScroll = $(this).scrollTop();
			if (newScroll >= 60 && newScroll <= finishDivScroll) {
				$("body").addClass("body-scrolled");
				$("header").addClass("header-transparent");
			} else if ($(this).scrollTop() > finishDivScroll) {
				$("header").removeClass("header-transparent");
			} else {
				$("body").removeClass("body-scrolled");
			}
		});
	} else {
		$(window).scroll(function () {
			if ($(this).scrollTop() >= 60) {
				$("body").addClass("body-scrolled");
			} else {
				$("body").removeClass("body-scrolled");
			}
		});
	}
}

function mobileMenuClose() {
	$(".mobile-menu").removeClass("mobile-menu-active");
	$("html, body").removeClass("body-overflow");
}

function shopMenu() {
	$(".shop-menu-button").on({
		mouseover: function (e) {
			if (!$(".shop-menu-active")[0]) {
				if ($(".header-transparent")[0]) {
					$("header").addClass("header-transparent-disabled");
				}
				$(".shop-menu-button").addClass("shop-menu-button-active");
				$(".shop-menu").addClass("shop-menu-active");
				$(".shop-menu").css("opacity", "1");
			}
		},
	});
	$(".shop-menu").on({
		mouseleave: function (e) {
			if ($(".header-transparent-disabled")[0]) {
				$("header").removeClass("header-transparent-disabled");
			}
			$(".shop-menu")
				.css("opacity", "0")
				.promise()
				.done(function () {
					$(".shop-menu").removeClass("shop-menu-active");
					$(".shop-menu-button").removeClass("shop-menu-button-active");
				});
		},
	});
}

function closeCartMenu() {
	$(".cart-menu-modal").removeClass("cart-menu-modal-active");
	if ($(window).width() < 992) {
		$("html, body").removeClass("body-overflow");
	} else {
		$("body").removeClass("body-overflow");
	}
}

function closeSearchMenu() {
	$(".search-menu-modal").removeClass("search-menu-modal-active");
	$("#searchinput").val("");
	$(".search-menu-results").hide();
	if ($(".header-transparent-disabled")[0]) {
		$("header").removeClass("header-transparent-disabled");
	}
	$("html, body").removeClass("body-overflow");
}

function closeAccountMenu() {
	$(".account-menu-modal").removeClass("account-menu-modal-active");
	$("#signinmodal").show();
	$("#signupmodal, #forgotmodal").hide();
	if ($(".header-transparent-disabled")[0]) {
		$("header").removeClass("header-transparent-disabled");
	}
	if ($(window).width() < 992) {
		$("html, body").removeClass("body-overflow");
	}
}

function generalSlideshow() {
	if ($(".general-slideshow-section")[0]) {
		var generalslidershowright = new Swiper(".general-slideshow-right-slider", {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			freeMode: false,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
		});
		var generalslidershowleft = new Swiper(".general-slideshow-left-slider", {
			loop: true,
			spaceBetween: 0,
			watchSlidesProgress: true,
			navigation: {
				nextEl: ".general-slideshow-icon-arrow-next",
				prevEl: ".general-slideshow-icon-arrow-prev",
			},
			pagination: {
				el: ".swiper-pagination-general-slideshow",
				clickable: true,
			},
			breakpoints: {
				992: {
					pagination: {
						enabled: false,
					},
				},
			},
		});
		generalslidershowright.controller.control = generalslidershowleft;
		generalslidershowleft.controller.control = generalslidershowright;

		// Update CSS var --slide-bg-color on the closest .shopify-section
		function setSectionBgFromActive() {
			var $activeSlide = $(generalslidershowleft.slides[generalslidershowleft.activeIndex]);
			if (!$activeSlide || !$activeSlide.length) return;
			var color = $activeSlide.attr("data-slide-bg-color") || $activeSlide.data("slide-bg-color");
			if (!color) return;
			var sectionEl = $(generalslidershowleft.el).closest(".shopify-section")[0];
			if (sectionEl) {
				sectionEl.style.setProperty("--slide-bg-color", color);
			}
		}

		// Set on init and when slides change on either synced slider
		setSectionBgFromActive();
		generalslidershowleft.on("slideChange", setSectionBgFromActive);
	}
}

function footerSlider() {
	if ($(".footer-slider")[0]) {
		// var generalslidershowright = new Swiper(".footer-slider", {
		// 	slidesPerView: 2.5,
		// 	centeredSlides: true,
		// 	loop: true,
		// 	center: true,
		// 	spaceBetween: 16,
		// 	freeMode: true,
		// 	breakpoints: {
		// 		992: {
		// 			centeredSlides: false,
		// 			slidesPerView: 4,
		// 			spaceBetween: 24,
		// 		},
		// 	},
		// });
		var generalslidershowright = new Swiper(".footer-slider", {
			slidesPerView: 2.5,
			centeredSlides: true,
			loop: true,
			spaceBetween: 16,

			breakpoints: {
				992: {
					centeredSlides: false,
					slidesPerView: 4,
					spaceBetween: 24,
					speed: 0, // Disable Swiper transitions
					autoplay: false, // Disable Swiper autoplay
					allowTouchMove: false, // Disable dragging
				},
			},
		});
	}
}

function wholesaleSlider() {
	if ($(".wholesale-cards-mobile-slider")[0]) {
		const wholesaleSlider = new Swiper(".wholesale-cards-mobile-slider", {
			slidesPerView: 1.5,
			spaceBetween: 16,
			grabCursor: true,
			pagination: {
				el: ".wholesale-cards-mobile .swiper-pagination",
				clickable: true,
			},
		});
	}
}

// Benefits slider
// let swiperEnabled;

// function benefitsSwiper() {
// 	if (!swiperEnabled) {
// 		swiperEnabled = new Swiper(".benefits-cards-slider-mobile", {
// 			loop: false,
// 			slidesPerView: 2,
// 			grid: {
// 				rows: 3,
// 			},
// 			slidesPerGroup: 3,
// 			spaceBetween: 10,
// 			pagination: {
// 				el: ".benefits-cards-slider-mobile .swiper-pagination",
// 				clickable: true,
// 			},
// 		});
// 	}
// }

// function checkBenefitsSliderWidth() {
// 	if (window.innerWidth < 992) {
// 		benefitsSwiper();
// 	} else {
// 		// Destroy Swiper instance if window is resized above 992px
// 		if (swiperEnabled) {
// 			swiperEnabled.destroy();
// 			swiperEnabled = null; // Reset swiper variable
// 		}
// 	}
// }

// // Add event listener for resize
// window.addEventListener("resize", checkBenefitsSliderWidth);

function benefitsMobileSwiper() {
	if ($(".benefits-cards-mobile")[0]) {
		swiperEnabled = new Swiper(".benefits-cards-mobile", {
			loop: false,
			slidesPerView: 2,
			spaceBetween: 10,
			pagination: {
				el: ".benefits-cards-mobile .swiper-pagination",
				clickable: true,
			},
		});
	}
}

// Sustain slider
let swiperSustainEnabled;

function sustainSwiper() {
	if (!swiperSustainEnabled) {
		swiperSustainEnabled = new Swiper(".sustain-steps-slider", {
			loop: false,
			slidesPerView: 2,
			spaceBetween: 70,
			pagination: {
				el: ".sustain-steps-slider .swiper-pagination",
				clickable: true,
			},
		});
	}
}

function checkSustainSliderWidth() {
	if (window.innerWidth < 992) {
		sustainSwiper();
	} else {
		// Destroy Swiper instance if window is resized above 992px
		if (swiperSustainEnabled) {
			swiperSustainEnabled.destroy();
			swiperSustainEnabled = null; // Reset swiper variable
		}
	}
}

// Add event listener for resize
window.addEventListener("resize", checkSustainSliderWidth);

function generalSlideshowV2() {
	if ($(".general-slideshow-v2-section")[0]) {
		const generalslidershowright = new Swiper(".general-slideshow-v2-right-slider", {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			freeMode: false,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
		});
		const generalslidershowleft = new Swiper(".general-slideshow-v2-left-slider", {
			loop: true,
			spaceBetween: 0,
			watchSlidesProgress: true,
			autoHeight: true,
			navigation: {
				nextEl: ".general-slideshow-v2-icon-arrow-next",
				prevEl: ".general-slideshow-v2-icon-arrow-prev",
			},
			pagination: {
				el: ".swiper-pagination-general-slideshow-v2",
				clickable: true,
			},
			breakpoints: {
				992: {
					pagination: {
						enabled: false,
						autoHeight: false,
					},
				},
			},
		});
		generalslidershowright.controller.control = generalslidershowleft;
		generalslidershowleft.controller.control = generalslidershowright;
	}
}

// Scrollable elements
$(".scrollable-element").on("click", function () {
	var getScrollDiv = $(this).attr("data-scroll");
	if ($(getScrollDiv).length != 0) {
		$("html, body").animate({ scrollTop: $(getScrollDiv).offset().top - 80 }, 1200);
	}
});

// On Window Resize Check some functions
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

var resizeStart = debounce(function () {
	menuScroll();
}, 200);

window.addEventListener("resize", resizeStart);

// Show more colors
$("header").on("click touch", ".general-product-style-select-icon-more", function () {
	$(this).parent().toggleClass("show-all");
});

$("main").on("click", ".general-product-style-select-icon-more", function () {
	$(this).parent().toggleClass("show-all");
});

// Show more gift options
$(".general-product-style-select-icon-more-gift").on("click", function () {
	$(this).parent().toggleClass("show-all");
});

// Sustain Slideshow
function sustainSlideshow() {
	if ($(".sust-slideshow-section")[0]) {
		var sustainslidershowright = new Swiper(".sust-slideshow-right-slider", {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			freeMode: false,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
		});
		var sustainslidershowleft = new Swiper(".sust-slideshow-left-slider", {
			loop: true,
			spaceBetween: 0,
			watchSlidesProgress: true,
			autoHeight: true,
			navigation: {
				nextEl: ".sust-slideshow-icon-arrow-next",
				prevEl: ".sust-slideshow-icon-arrow-prev",
			},
			pagination: {
				el: ".swiper-pagination-sust-slideshow",
				clickable: true,
			},
			breakpoints: {
				992: {
					pagination: {
						enabled: false,
					},
					autoHeight: false,
				},
			},
		});
		sustainslidershowright.controller.control = sustainslidershowleft;
		sustainslidershowleft.controller.control = sustainslidershowright;
	}
}
